<template>
    <b-button
            :disabled="loading"
            class="btn btn-success bg-success br3 border-0 text-uppercase font-weight-bold py-2 fz20 d-block w-100 mt-3"
            type="submit">
        <b-spinner class="v-align-txt-baseline" small v-if="loading"></b-spinner>
        {{loading ? loadingText : defaultText }}
    </b-button>
</template>

<script>
    export default {
        name: "CustomButton",
        props: {
            loading: Boolean,
            defaultText: {
                type: String,
                default: 'Submit'
            },
            loadingText: {
                type: String,
                default: 'Submitting'
            }
        }
    }
</script>

<style scoped>

</style>
